<template>
  <main>
    <van-tabs
      sticky
      color="#1989fa"
      lazy-render
      animated
      v-model="active"
      :swipe-threshold="4"
      
    >
      <van-tab title="项目信息预览">
        <div>
          <b-row style="padding: 0 10px" ref="xmyls">
            <b-form-group
              label="责任单位"
              label-for="input-1"
              class="col-md-12 mb-3"
              v-if="zrShow"
              style="
                font-size: 14px;
                color: #646566;
                background-color: #ffffff;
                margin-top: 5px;
                padding-top: 10px;
              "
            >
              <b-form-select
                style="font-size: 14px"
                v-model="yl_zrCompanyId"
                :options="zrOptions"
                required
                id="inline-form-custom-select-pref1"
                @change="fw_zrCompanyChange"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              label="项目名称"
              class="col-md-6 mb-3"
              label-for="input-1"
            >
              <b-form-input
                v-model="xmform.projectName"
                type="text"
                required
                placeholder="请输入项目名称"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="项目状态"
              class="col-md-6 mb-3"
              label-for="input-1"
            >
              <b-form-select
                v-model="xmform.state"
                :options="xmyl.options5"
                required
                id="inline-form-custom-select-pref1"
              ></b-form-select>
            </b-form-group>
            <div class="col-md-6" style="text-align: right" v-if="showMore">
              <b-badge
                variant="info"
                style="font-size: 16px; background-color: #1779cc !important"
                @click="showMore = false"
                >更多筛选项</b-badge
              >
            </div>
            <b-form-group
              label="产业方向"
              class="col-md-6 mb-3"
              label-for="input-1"
              v-if="!showMore"
            >
              <b-form-select
                v-model="xmform.canye"
                :options="xmyl.options4"
                required
                id="inline-form-custom-select-pref1"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              label="投资主体"
              v-if="!showMore"
              class="col-md-6 mb-3"
              label-for="input-1"
            >
              <b-form-input
                v-model="xmform.companyName"
                type="text"
                required
                placeholder="请输入投资主体"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="建设性质"
              v-if="!showMore"
              class="col-md-6 mb-3"
              label-for="input-1"
            >
              <b-form-select
                v-model="xmform.buildType"
                :options="xmyl.options2"
                required
                id="inline-form-custom-select-pref1"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              label="产业类别"
              v-if="!showMore"
              class="col-md-6 mb-3"
              label-for="input-1"
            >
              <b-form-select
                v-model="xmform.projectType"
                :options="xmyl.options3"
                required
                id="inline-form-custom-select-pref1"
              ></b-form-select>
            </b-form-group>

            <b-form-group
              label="合同类型"
              v-if="!showMore"
              class="col-md-6 mb-3"
              label-for="input-1"
            >
              <b-form-select
                v-model="xmform.htType"
                :options="xmyl.options7"
                required
                id="inline-form-custom-select-pref1"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              label="签约时间范围-起始："
              v-if="!showMore"
              class="col-md-6 mb-3"
              label-for="input-1"
            >
              <b-form-datepicker
                type="text"
                placeholder="开始时间"
                v-model="xmform.signDateStart"
              ></b-form-datepicker>
            </b-form-group>
            <b-form-group
              label="签约时间范围-结束："
              v-if="!showMore"
              class="col-md-6 mb-3"
              label-for="input-1"
            >
              <b-form-datepicker
                type="text"
                placeholder="结束时间"
                v-model="xmform.signDateEnd"
              ></b-form-datepicker>
            </b-form-group>
            <b-form-group
              label="合同投资额："
              v-if="!showMore"
              class="col-md-6 mb-3"
              label-for="input-1"
            >
              <b-row>
                <div class="col-5 col-sx-5">
                  <b-form-select
                    :options="xmyl.options6"
                    v-model="xmform.httzft"
                  ></b-form-select>
                </div>
                <div class="col-7 col-sx-7" style="padding-left: 0">
                  <b-form-input
                    type="text"
                    placeholder="单位: 亿元"
                    v-model="xmform.httzftVal"
                  ></b-form-input>
                </div>
              </b-row>
            </b-form-group>
            <!-- <b-form-group
              label="达产营收值："
              v-if="!showMore"
              class="col-md-6 mb-3"
              label-for="input-1"
            >
              <b-row>
                <div class="col-5 col-sx-5">
                  <b-form-select
                    :options="xmyl.options6"
                    v-model="xmform.dcysft"
                  ></b-form-select>
                </div>
                <div class="col-7 col-sx-7" style="padding-left: 0">
                  <b-form-input
                    type="text"
                    placeholder="单位: 亿元"
                    v-model="xmform.dcysftVal"
                  ></b-form-input>
                </div>
              </b-row>
            </b-form-group> -->
            <b-form-group
              label="项目平衡周期(年)："
              v-if="!showMore"
              class="col-md-6 mb-3"
              label-for="input-1"
            >
              <b-row>
                <div class="col-5 col-sx-5">
                  <b-form-select
                    :options="xmyl.options6"
                    v-model="xmform.phzqft"
                  ></b-form-select>
                </div>
                <div class="col-7 col-sx-7" style="padding-left: 0">
                  <b-form-input
                    type="text"
                    placeholder="单位: 年"
                    v-model="xmform.phzqftVal"
                  ></b-form-input>
                </div>
              </b-row>
            </b-form-group>
            <b-form-group
              label="合同期内给予政策扶持总金额："
              v-if="!showMore"
              class="col-md-6 mb-3"
              label-for="input-1"
            >
              <b-row>
                <div class="col-5 col-sx-5">
                  <b-form-select
                    :options="xmyl.options6"
                    v-model="xmform.htfcft"
                  ></b-form-select>
                </div>
                <div class="col-7 col-sx-7" style="padding-left: 0">
                  <b-form-input
                    type="text"
                    placeholder="单位: 万元"
                    v-model="xmform.htfcftVal"
                  ></b-form-input>
                </div>
              </b-row>
            </b-form-group>
            <b-form-group
              label="合同期内区级税收总贡献："
              v-if="!showMore"
              class="col-md-6 mb-3"
              label-for="input-1"
            >
              <b-row>
                <div class="col-5 col-sx-5">
                  <b-form-select
                    :options="xmyl.options6"
                    v-model="xmform.qyssft"
                  ></b-form-select>
                </div>
                <div class="col-7 col-sx-7" style="padding-left: 0">
                  <b-form-input
                    type="text"
                    placeholder="单位: 万元"
                    v-model="xmform.qyssftVal"
                  ></b-form-input>
                </div>
              </b-row>
            </b-form-group>
            <div style="width: 100%">
              <b-col md="12 text-center">
                <b-button
                  style="width: 100px"
                  class="mt-3 w-50 button-color"
                  @click="searchxmyl()"
                  variant="primary"
                  >查询</b-button
                >
              </b-col>
            </div>
            <div style="padding: 15px; width: 100%" v-if="isNoData">
              <div
                style="
                  margin-top: 20px;
                  background-color: rgba(102, 51, 153, 0.06);
                  padding: 8px;
                  border-radius: 8px;
                  line-height: 1.5;
                  font-size: 15px;
                  font-family: -apple-system, BlinkMacSystemFont,
                    'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto,
                    'PingFang SC', miui, 'Hiragino Sans GB', 'Microsoft Yahei',
                    sans-serif;
                "
              >
                <div style="text-align: center">暂无数据</div>
              </div>
            </div>
            <div
              style="padding: 15px; width: 100%"
              v-if="xmyl.tableList.length"
            >
              <div
                style="
                  margin-top: 20px;
                  background-color: #fff;
                  padding: 8px;
                  border-radius: 8px;
                  line-height: 1.5;
                  font-size: 15px;
                  font-family: 黑体;
                "
              >
                <div>
                  <span>项目总数：{{ xmyl.tableList.length || 0 }}</span>
                </div>
                <div>
                  <span
                    class="badge badge-info"
                    style="
                      background-color: rgb(23, 121, 204) !important;
                      font-size: 11pt;
                      margin-top: 5px;
                    "
                  >
                    <a
                      style="background-color: rgba(102, 51, 153, 0.06)"
                      @click="setState('前期接触')"
                    >
                      前期接触({{
                        xmyl.tableList.filter(
                          (item) => item.status == "前期接触"
                        ).length || 0
                      }})
                    </a>
                  </span>
                  &nbsp;&nbsp;

                  <span
                    class="badge badge-info"
                    style="
                      background-color: rgb(23, 121, 204) !important;
                      font-size: 11pt;
                      margin-top: 5px;
                    "
                  >
                    <a
                      style="background-color: rgba(102, 51, 153, 0.06)"
                      @click="setState('预期落地')"
                    >
                      预期落地({{
                        xmyl.tableList.filter(
                          (item) => item.status == "预期落地"
                        ).length || 0
                      }})
                    </a>
                  </span>
                  &nbsp;&nbsp;

                  <span
                    class="badge badge-info"
                    style="
                      background-color: rgb(23, 121, 204) !important;
                      font-size: 11pt;
                      margin-top: 5px;
                    "
                  >
                    <a
                      style="background-color: rgba(102, 51, 153, 0.06)"
                      @click="setState('过会未签')"
                    >
                      过会未签({{
                        xmyl.tableList.filter(
                          (item) => item.status == "过会未签"
                        ).length || 0
                      }})
                    </a>
                  </span>
                  &nbsp;&nbsp;

                  <span
                    class="badge badge-info"
                    style="
                      background-color: rgb(23, 121, 204) !important;
                      font-size: 11pt;
                      margin-top: 5px;
                    "
                  >
                    <a
                      style="background-color: rgba(102, 51, 153, 0.06)"
                      @click="setState('已签未落')"
                    >
                      已签未落({{
                        xmyl.tableList.filter(
                          (item) => item.status == "已签未落"
                        ).length || 0
                      }})
                    </a>
                  </span>
                  &nbsp;&nbsp;

                  <span
                    class="badge badge-info"
                    style="
                      background-color: rgb(23, 121, 204) !important;
                      font-size: 11pt;
                      margin-top: 5px;
                    "
                  >
                    <a
                      style="background-color: rgba(102, 51, 153, 0.06)"
                      @click="setState('已落未建')"
                    >
                      已落未建({{
                        xmyl.tableList.filter(
                          (item) => item.status == "已落未建"
                        ).length || 0
                      }})
                    </a>
                  </span>
                  &nbsp;&nbsp;

                  <span
                    class="badge badge-info"
                    style="
                      background-color: rgb(23, 121, 204) !important;
                      font-size: 11pt;
                      margin-top: 5px;
                    "
                  >
                    <a
                      style="background-color: rgba(102, 51, 153, 0.06)"
                      @click="setState('开工建设')"
                    >
                      开工建设({{
                        xmyl.tableList.filter(
                          (item) => item.status == "开工建设"
                        ).length || 0
                      }})
                    </a>
                  </span>
                  &nbsp;&nbsp;

                  <span
                    class="badge badge-info"
                    style="
                      background-color: rgb(23, 121, 204) !important;
                      font-size: 11pt;
                      margin-top: 5px;
                    "
                  >
                    <a
                      style="background-color: rgba(102, 51, 153, 0.06)"
                      @click="setState('建成投产')"
                    >
                      建成投产({{
                        xmyl.tableList.filter(
                          (item) => item.status == "建成投产"
                        ).length || 0
                      }})
                    </a>
                  </span>
                  &nbsp;&nbsp;

                  <span
                    class="badge badge-info"
                    style="
                      background-color: rgb(23, 121, 204) !important;
                      font-size: 11pt;
                      margin-top: 5px;
                    "
                  >
                    <a
                      style="background-color: rgba(102, 51, 153, 0.06)"
                      @click="setState('投产达产')"
                    >
                      投产达产({{
                        xmyl.tableList.filter(
                          (item) => item.status == "投产达产"
                        ).length || 0
                      }})
                    </a>
                  </span>
                  &nbsp;&nbsp;

                  <span
                    class="badge badge-info"
                    style="
                      background-color: rgb(23, 121, 204) !important;
                      font-size: 11pt;
                      margin-top: 5px;
                    "
                  >
                    <a
                      style="background-color: rgba(102, 51, 153, 0.06)"
                      @click="setState('已停止')"
                    >
                      已停止({{
                        xmyl.tableList.filter((item) => item.status == "已停止")
                          .length || 0
                      }})
                    </a>
                  </span>
                </div>
                <div>
                  <span style="font-size: 11pt; margin-top: 5px"
                    >合同投资额（亿元）：{{ countTexta || 0 }}</span
                  >
                </div>
                <!-- <div>
                  <span style="font-size: 11pt; margin-top: 5px"
                    >达产营收/产值（亿元）：{{ countTextb || 0 }}</span
                  >
                </div> -->
              </div>
            </div>
            <div style="width: 100%">
              <b-col
                cols="12"
                v-for="(item, index) in xmyl.tableList"
                :key="index"
              >
                <b-card
                  style="line-height:1.5;width:95%;margin:0 auto;font-family: -apple-system,BlinkMacSystemFont,'Helvetica Neue',Helvetica,Segoe UI,Arial,Roboto,'PingFang SC',miui,'Hiragino Sans GB','Microsoft Yahei',sans-serif;
}"
                  class="mt-3 card-icon-bg card-icon-bg-primary o-hidden"
                >
                  <div class="content d-flex van-row--justify-space-between">
                    <p
                      class="card-title text-break"
                      style="font-size: 14px; font-family: 黑体"
                    >
                      <b>{{ item.projectName }}</b>
                    </p>
                    <div class="d-flex card-title" style="align-items: center">
                      <van-tag
                        class="parmary-color text-nowrap"
                        style="margin: 0 10px"
                        >{{ item.natureName }}</van-tag
                      >
                      <van-tag class="parmary-color text-nowrap">{{
                        item.stausDescription
                      }}</van-tag>
                    </div>
                  </div>

                  <!-- 项目编号 -->

                  <div
                    class="mt-2 fontSize d-flex van-row--justify-space-between"
                  >
                    <div class="item-title">项目编号：</div>
                    <div style="width: 100%">{{ item.projectNo }}</div>
                  </div>

                  <div
                    class="mt-2 fontSize d-flex van-row--justify-space-between"
                  >
                    <div class="item-title">招商牵头单位：</div>
                    <div style="width: 100%">{{ item.zsqtdw_name }}</div>
                  </div>

                  <div
                    class="mt-2 fontSize d-flex van-row--justify-space-between"
                  >
                    <div class="item-title">落地保障单位：</div>
                    <div style="width: 100%">{{ item.ldzrdw_name }}</div>
                  </div>

                  <div
                    class="mt-2 fontSize d-flex van-row--justify-space-between"
                  >
                    <div class="item-title">投资主体名称：</div>
                    <div style="width: 100%">{{ item.joinCompanys }}</div>
                  </div>

                  <div v-show="item.show">
                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">企业类型：</div>
                      <div style="width: 100%">{{ item.qylx }}</div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">项目建设内容：</div>
                      <div style="width: 100%">
                        {{ item.projectDescription }}
                      </div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div style="min-width: 100px; font-family: 黑体">
                        项目进展情况：
                      </div>
                      <div style="width: 100%">
                        <div class="timelinebox">
                          <el-timeline>
                            <el-timeline-item
                              color="#1779cc"
                              v-for="(activity, index) in item.timeline"
                              :key="index"
                              :timestamp="activity.timestamp"
                            >
                              <div>
                                {{ activity.content }}
                              </div>
                            </el-timeline-item>
                          </el-timeline>
                        </div>
                      </div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">项目选址区域：</div>
                      <div style="width: 100%">{{ item.luoHuDiZhi }}</div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">产业类别：</div>
                      <div style="width: 100%">{{ item.projectType }}</div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">产业方向：</div>
                      <div style="width: 100%">{{ item.canye }}</div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">项目类别：</div>
                      <div style="width: 100%">{{ item.state }}</div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">合同类型：</div>
                      <div style="width: 100%">{{ item.htType }}</div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">合同投资额（亿元）：</div>
                      <div style="width: 100%">{{ item.httz }}</div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">签约时间：</div>
                      <div style="width: 100%">{{ item.signTime }}</div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">开工时间(或未开工原因)：</div>
                      <div style="width: 100%">{{ item.kgStatus }}</div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">投产时间：</div>
                      <div style="width: 100%">{{ item.productionTime }}</div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">需统筹解决的问题：</div>
                      <div style="width: 100%">
                        {{ item.needTobeCoordinatedAndResolved }}
                      </div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">预计区级经济贡献情况：</div>
                      <div style="width: 100%">{{ item.jjgx }}</div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">约定政策扶持事项：</div>
                      <div style="width: 100%">
                        {{ item.preferentialPolicy }}
                      </div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">政策扶持兑现状态：</div>
                      <div style="width: 100%">
                        {{ item.preferentialPolicyState }}
                      </div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">企业联系人及电话：</div>
                      <div style="width: 100%">
                        {{ item.contactPerson }} {{ item.contactNumber }}
                      </div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">项目联系人及电话：</div>
                      <div style="width: 100%">
                        {{ item.pContactPerson }} {{ item.pContactNumber }}
                      </div>
                    </div>

                    <div
                      class="mt-2 fontSize d-flex van-row--justify-space-between"
                    >
                      <div class="item-title">备注：</div>
                      <div style="width: 100%">{{ item.remake }}</div>
                    </div>
                  </div>

                  <div class="item-clis">
                    <div v-if="canEdit(item)"
                      @click.stop="onItemClick(item)"
                      style="margin-right: 13px"
                    >
                      管理
                    </div>
                    <div
                      style="margin-right: 20px"
                      @click.stop="changeshow(item)"
                    >
                      {{ item.show == true ? "收起" : "详情" }}
                    </div>
                  </div>
                </b-card>
              </b-col>
            </div>

            <div style="height: 200px; width: 100%"></div>
          </b-row>
        </div>
      </van-tab>
    </van-tabs>
    <van-overlay :show="yl_listLoading">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" color="#1989fa" />
        <span style="color: #0062cc">加载中...</span>
      </div>
    </van-overlay>
    <metabBar />
    <van-calendar
      :min-date="minDate"
      :max-date="maxDate"
      v-model="showCalendar1"
      @confirm="onConfirm1"
    />
    <van-calendar
      :min-date="minDate"
      :max-date="maxDate"
      v-model="showCalendar2"
      @confirm="onConfirm2"
    />
    <van-calendar
      :min-date="minDate_x"
      :max-date="maxDate_x"
      :default-date="value_xd1"
      v-model="showCalendar_x1"
      @confirm="onConfirm_x1"
    />
    <van-calendar
      :min-date="minDate_x"
      :max-date="maxDate_x"
      :default-date="value_xd2"
      v-model="showCalendar_x2"
      @confirm="onConfirm_x2"
    />
    <van-popup v-model="showCalendar3" round position="bottom">
      <van-datetime-picker
        v-model="e10currentStartDate"
        type="year"
        title="选择年份"
        :min-date="minDate2"
        :max-date="maxDate2"
        :formatter="e10formatter"
        @cancel="showCalendar3 = false"
        @confirm="onConfirm3"
      />
    </van-popup>
    <van-popup v-model="showCalendar4" round position="bottom">
      <van-datetime-picker
        v-model="e10currentEndDate"
        type="year"
        title="选择年份"
        :min-date="minDate2"
        :max-date="maxDate2"
        :formatter="e10formatter"
        @cancel="showCalendar4 = false"
        @confirm="onConfirm4"
      />
    </van-popup>

    <!-- <van-dialog v-model="showCalendar5" title="修改进展情况" show-cancel-button>
      



      <div style="margin: 16px">
        <van-button round block type="info" @click="editJz">提交</van-button>
      </div>
    </van-dialog> -->
    <el-dialog
      title="修改进展情况"
      :visible.sync="showCalendar5"
      width="85%"
      :before-close="handleClose"
      append-to-body
    >
      <div class="content">
        <div class="edittext">项目进展情况</div>
        <div class="content-item">
          <el-input
            style="width: 220px"
            type="textarea"
            v-model="editobj.content"
          ></el-input>
        </div>
      </div>

      <div class="content2">
        <div class="edittime">具体日期</div>
        <div>
          <el-date-picker
            v-model="editobj.timestamp"
            type="month"
            placeholder="选择日期"
          >
          </el-date-picker>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showCalendar5 = false">取 消</el-button>
        <el-button type="primary" @click="editJz">确 定</el-button>
      </span>
    </el-dialog>

    <!--  选择日期 -->
  </main>
</template>

<script>
import qs from "qs";
import getBar from "./data/bar";
import bar1 from "./data/bar1";
import bar2 from "./data/bar2";
import bar3 from "./data/bar3";
import bar4 from "./data/bar4";
import bar5 from "./data/bar5";
import bar6 from "./data/bar6";
import bar7 from "./data/bar7";
import bar8 from "./data/bar8";
import { computingTime } from "@/auth/utils";
import metabBar from "@/components/metabBar";
import { echartBar10, toThousands } from "./config";
import { dateFormat, isEmpty, isNumber } from "@/utils/common-api";
 
import { getCountProjectList } from "@/apis/company";
import { Notify } from "vant";
import { getAllSassOrg } from "@/apis/company";
import {
  constants_options_cyfx,
  constants_options_cylb,
  constants_options_project_state,
  constants_options_qylx,
  constants_optisons_jhld,
  constants_options_xmcy,
} from "@/constants";
export default {
  components: {
    metabBar,
  },
  data() {
    const options = qs.parse(location.search, { ignoreQueryPrefix: true });
    let nowDate = new Date();
    const lastDate = nowDate.setFullYear(nowDate.getFullYear() - 1);

    return {
      user:JSON.parse(localStorage.getItem("userInfo")).currentUser,
      zrShow: false,
      value: "",
      showCalendar: false,
      Xmqkcontent: "",
      dou_zrCompanyId: 0,
      xm_zrCompanyId: 0,
      qy_zrCompanyId: 0,
      fw_zrCompanyId: 0,
      yl_zrCompanyId: 0,
      yl_listLoading: false,
      showbar3: true,
      showbar4: true,
      showbar6: true,
      showbar7: true,
      showbar8: true,
      showMore: true,
      isNoData: false,

      // 项目统计是否显示时间条件
      bar2status: true,
      showtimeC: true,
      StatisticsData: {},
      xianshuo: {},
      active: 0,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2045, 0, 31),
      minDate_x: new Date(2020, 0, 1),
      maxDate_x: new Date(2045, 0, 31),
      minDate2: new Date(2000, 0, 1),
      maxDate2: new Date(2045, 0, 1),
      value1: computingTime().value1,
      value2: computingTime().value2,
      value_x1: dateFormat(new Date(lastDate)),
      value_x2: dateFormat(new Date()),
      value_xd1: new Date(lastDate),
      value_xd2: new Date(),
      value3: (new Date().getFullYear() - 4).toString(),
      value4: new Date().getFullYear().toString(),
      Monthly: "true",
      DispayType: 20,
      showCalendar1: false,
      showCalendar2: false,
      showCalendar_x1: false,
      showCalendar_x2: false,
      showCalendar3: false,
      showCalendar4: false,
      showCalendar5: false,
      e10currentStartDate: new Date(new Date().getFullYear() - 4, 0, 1),
      e10currentEndDate: new Date(),
      options,
      bar: getBar(),
      bar1: bar1(),
      bar2: bar2(),
      bar3: bar3(),
      bar4: bar4(),
      bar5: bar5(),
      bar6: bar6(),
      bar7: bar7(),
      bar8: bar8(),
      echartBar10: echartBar10,
      initOptions: {
        renderer: options.renderer || "canvas",
      },
      xmyl: {
        tableList: [],
        options1: [],
        options2: [
          { value: "", text: "请选择" },
          { value: "新建", text: "新建" },
          { value: "扩建", text: "扩建" },
          { value: "改建和技术改造", text: "改建和技术改造" },
          { value: "单纯建造生活设施", text: "单纯建造生活设施" },
          { value: "迁建", text: "迁建" },
          { value: "恢复", text: "恢复" },
          { value: "单纯购置", text: "单纯购置" },
        ],
        options3: [
          { value: "-1", text: "请选择" }, ...constants_options_cylb
        ],
        options4: [
          { value: "", text: "请选择" },
            ...constants_options_cyfx
        ],
        options5: [
          { value: "", text: "请选择" },
          ...constants_options_project_state
        ],
        options6: [
          { value: "大于等于", text: "大于等于" },
          { value: "小于等于", text: "小于等于" },
        ],
        options7: [
          { value: "", text: "请选择" },
          { value: "正式合同", text: "正式合同" },
          { value: "战略合作协议", text: "战略合作协议" },
        ],
      },
      xmform: {
        projectName: "", // 项目名称
        zrCompanyId: 0, // 责任单位
        companyName: "", // 投资主体
        buildType: "", // 建设性质
        projectType: "-1", // 产业类别
        state: "", // 项目状态
        canye: "", // 产业方向
        httzft: "大于等于", // 合同投资额计算符
        httzftVal: "", // 合同投资额对比值
        dcysft: "大于等于", // 达产营收值计算符
        dcysftVal: "", // 达产营收值对比值
        phzqft: "大于等于", // 项目平衡周期（年）计算符
        phzqftVal: "", // 项目平衡周期（年）对比值
        htfcft: "大于等于", // 合同期内给予政策扶持总金额计算符
        htfcftVal: "", // 合同期内给予政策扶持总金额对比值
        qyssft: "大于等于", // 合同期内区级税收总贡献计算符
        qyssftVal: "", // 合同期内区级税收总贡献对比值
        signDateStart: "", // 签约时间范围-开始
        signDateEnd: "", // 签约时间范围-结束
        htType: "", // 合同类型
      },
      editobj: {},
      activities: [],
      zrOptions: [],
      eidtId: null,
    };
  },
  methods: {
    editJz() {
      //修改进度
      this.activities.forEach((item) => {
        if (item.id == this.editobj.id) {
          item.content = this.editobj.content;
          item.timestamp = this.$moment(this.editobj.timestamp).format(
            "YYYY-MM-DD"
          );
        }
      });
      let data = {
        Id: this.eidtId,
        ProjectProcessText: JSON.stringify(this.activities),
      };
      this.request({
        url: "/v1.0/Project/xiangmutuijinqingkuang",
        method: "post",
        data: data,
      }).then((res) => {
        console.log(res, 7777);
        if (res.success) {
          console.log(11111);
          this.$toast.success("修改成功");
          this.searchxmyl();
        }
      });
      this.showCalendar5 = false.catch(() => {});
    },
    edititem(id, arr, itm, idx) {
      this.eidtId = id;
      this.activities = arr;
      this.showCalendar5 = true;
      this.editobj = JSON.parse(JSON.stringify(itm));
    },

    delevolveitem(id, arr, itm, idx) {
      //删除进度
      let list = arr.filter((val) => val.content !== itm.content);
      console.log(list, 444444);
      let data = {
        Id: id,
        ProjectProcessText: JSON.stringify(list),
      };
      this.request({
        url: "/v1.0/Project/xiangmutuijinqingkuang",
        method: "post",
        data: data,
      }).then((res) => {
        console.log(res, 7777);
        if (res.success) {
          console.log(11111);
          this.$toast.success("删除成功");
          this.searchxmyl();
        }
      });
    },
    handleClose() {
      this.showCalendar5 = false;
    },
    setState(val) {
      this.searchxmyl(val);
    },
    onItemClick(item) {
      this.$router.push(`/index/programDetail?id=${item.id}`);
    },
    canEdit(item){
      // var user  = JSON.parse(localStorage.getItem("userInfo")).currentUser;
      return item.employerName==this.user.employerName;
    },
    changeshow(data) {
      this.$nextTick(() => {
        var datalist = [];
        for (var i = 0; i < this.xmyl.tableList.length; i++) {
          var item = this.xmyl.tableList[i];
          try {
            item.qylx = item.qylx ? JSON.parse(item.qylx)?.join(",") : "";
          } catch {}

          if (item.id == data.id) {
            if (item.show) {
              item.show = !item.show;
            } else {
              item.show = true;
            }
          }
          datalist.push(item);
        }
        this.xmyl.tableList = datalist;
      });
    },
    searchxmyl(v) {
      if (!isEmpty(this.xmform.httzftVal) && !isNumber(this.xmform.httzftVal)) {
        Notify({ type: "warning", message: "合同投资额请输入数值类型" });
        return;
      }
      if (!isEmpty(this.xmform.dcysftVal) && !isNumber(this.xmform.dcysftVal)) {
        Notify({ type: "warning", message: "达产营收值请输入数值类型" });
        return;
      }
      if (!isEmpty(this.xmform.phzqftVal) && !isNumber(this.xmform.phzqftVal)) {
        Notify({ type: "warning", message: "项目平衡周期请输入数值类型" });
        return;
      }
      if (!isEmpty(this.xmform.htfcftVal) && !isNumber(this.xmform.htfcftVal)) {
        Notify({
          type: "warning",
          message: "合同期内给予政策扶持总金额请输入数值类型",
        });
        return;
      }
      if (!isEmpty(this.xmform.qyssftVal) && !isNumber(this.xmform.qyssftVal)) {
        Notify({
          type: "warning",
          message: "合同期内区级税收总贡献请输入数值类型",
        });
        return;
      }
      this.yl_listLoading = true;
      // this.xmform.state=v
      if (v) {
        this.xmform.state = v;
      } else {
      }
      this.isNoData = false;
      this.xmform.zrCompanyId = this.yl_zrCompanyId;
      this.xmform.isSummary=false;
      // 校验
      getCountProjectList(this.xmform)
        .then((res) => {
          if (res.data && res.data.length) {
            res.data.forEach((item, index) => {
              item.idx = index + 1;
              item.signTime = item.signTime ? item.signTime.split(" ")[0] : "";
            });
            this.xmyl.tableList = res.data;
            for (var i = 0; i < this.xmyl.tableList.length; i++) {
              let item = this.xmyl.tableList[i];
              item.show = false;
              if (item.projectProcessText != null) {
                this.$set(
                  item,
                  "timeline",
                  JSON.parse(item.projectProcessText)
                );
              }
            }
          } else {
            this.isNoData = true;
            this.xmyl.tableList = [];
          }
          this.yl_listLoading = false;
        })
        .catch((err) => {
          this.yl_listLoading = false;
        });
    },
    refresh2() {
      // this.getCount();
      this.getProjectStatusCount();
      // this.getIndustryCompanyCount();
    },
    showppp(type) {
      if (type == 1) {
        this.showCalendar4 = false;
        this.showCalendar3 = true;
      }
      if (type == 2) {
        this.showCalendar3 = false;
        this.showCalendar4 = true;
      }
    },
    e10formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    e10Handler(params) {
      this.$router.push({
        name: "e10_detial_1",
        query: {
          pids: params.data.pids.join(","),
          year: params.data.year,
          cids: params.data.cids.join(","),
        },
      });
    },
    onConfirm1(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var day = date.getDate();
      this.value1 = year + "-" + month + "-" + day;
      this.showCalendar1 = false;
    },
    onConfirm2(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var day = date.getDate();
      this.value2 = year + "-" + month + "-" + day;
      this.showCalendar2 = false;
    },
    onConfirm_x1(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var day = date.getDate();
      this.value_x1 = year + "-" + month + "-" + day;
      console.log(this.showCalendar_x1);
      this.showCalendar_x1 = false;
    },
    onConfirm_x2(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var day = date.getDate();
      this.value_x2 = year + "-" + month + "-" + day;
      this.showCalendar_x2 = false;
    },
    onConfirm3(date) {
      this.showCalendar3 = false;
      this.showCalendar4 = false;
      this.e10currentEndDate.setFullYear(date.getFullYear() + 4);
      this.value3 = date.getFullYear();
      this.value4 = date.getFullYear() + 4;
      this.getCompanyProjectComplatedCount();
    },
    onConfirm4(date) {
      console.log(date);
      this.showCalendar3 = false;
      this.showCalendar4 = false;
      this.e10currentStartDate.setFullYear(date.getFullYear() - 4);
      this.value4 = date.getFullYear();
      this.value3 = date.getFullYear() - 4;
      this.getCompanyProjectComplatedCount();
    },
    handleClick() {
      // console.log("click from echarts");
    },
    handleZrClick() {
      // console.log("click from zrender");
    },
    qy_zrCompanyChange() {
      // 企业统计选择责任单位时执行
      // 入驻、离区
      this.getCompanyCount();
      // 营收达产
      this.getCompanyProjectComplatedCount();
      // 企业行业分布
      this.getIndustrySignUpCount();
      // 离区原因统计
      this.getLeaveAreaCount();
      // 离区时间统计
      this.getLeaveAreaTimeCount();
    },
    fw_zrCompanyChange() {
      // 用户统计选择责任单位时执行
      // 访问量统计
      this.getAccessCount();
      // 时段统计
      this.getAccessTimePeriodCount();
      // IP分布
      this.getAccessIpAddressCount();
      // 访问趋势
      this.getAccessTrendCount();
    },
    // 访问趋势
    getAccessTrendCount() {
      this.showbar8 = false;
      this.request({
        url: "/v1.0/Count/getAccessTrendCount",
        method: "GET",
        params: {
          EndTime: this.value2,
          StartTime: this.value1,
          DispayType: this.DispayType,
          zrCompanyId: this.fw_zrCompanyId,
        },
      }).then((res) => {
        this.bar8.xAxis[0].data = [];
        this.bar8.series[0].data = [];
        if (res.success && res.data.length > 0) {
          res.data.map((item) => {
            this.bar8.xAxis[0].data.push(item.time);
            this.bar8.series[0].data.push(item.count);
          });
        }
        this.showbar8 = true;
      });
    },
    //ip分布
    getAccessIpAddressCount() {
      this.showbar7 = false;
      this.request({
        url: "/v1.0/Count/getAccessIpAddressCount",
        method: "GET",
        params: {
          zrCompanyId: this.fw_zrCompanyId,
        },
      }).then((res) => {
        this.bar7.xAxis[0].data = [];
        this.bar7.series[0].data = [];
        if (res.success && res.data.length > 0) {
          res.data.map((item) => {
            this.bar7.series[0].data.push(item.percentage);
            this.bar7.xAxis[0].data.push(item.city);
          });
        }
        this.showbar7 = true;
      });
    },
    //访问时段统计
    getAccessTimePeriodCount() {
      this.showbar6 = false;
      this.request({
        url: "/v1.0/Count/getAccessTimePeriodCount",
        method: "GET",
        params: {
          zrCompanyId: this.fw_zrCompanyId,
        },
      }).then((res) => {
        if (res.success) {
          this.bar6.xAxis[0].data = [];
          this.bar6.series[0].data = [];
          res.data.map((item) => {
            this.bar6.series[0].data.push(item.percentage);
            this.bar6.xAxis[0].data.push(item.timePeriod);
          });
        }
        this.showbar6 = true;
      });
    },
    //获取访问统计
    getAccessCount() {
      this.request({
        url: "/v1.0/Count/getAccessCount",
        method: "GET",
        params: {
          zrCompanyId: this.fw_zrCompanyId,
        },
      }).then((res) => {
        const { count, todayCount, yesterdayCount } = res.data;
        (this.xianshuo.count1 = count),
          (this.xianshuo.todayCount = todayCount),
          (this.xianshuo.yesterdayCount = yesterdayCount);
      });
    },
    //获取离区时间统计
    getLeaveAreaTimeCount() {
      this.request({
        url: "/v1.0/Count/getLeaveAreaTimeCount",
        method: "GET",
        params: {
          EndTime: this.value2,
          StartTime: this.value1,
          Monthly: this.Monthly,
          zrCompanyId: this.qy_zrCompanyId,
        },
      }).then((res) => {
        if (res.success) {
          this.bar5.legend.data = [];
          this.bar5.series = [];
          res.data.map((item) => {
            this.bar5.xAxis[0].data = [item.leaveAreaTime];
            this.bar5.legend.data.push(item.leaveAreaTime);
            this.bar5.series.push({
              name: item.leaveAreaTime,
              data: [item.count],
              label: {
                show: true,
                position: "top",
                color: "#0168c1",
                formatter: "{c}",
              },
              type: "bar",
              barGap: 0,
              color: "#33b2df",
              smooth: true,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowOffsetY: -2,
                  shadowColor: "rgba(0, 0, 0, 0.3)",
                },
              },
            });
          });
        }
      });
    },
    //离区原因统计
    getLeaveAreaCount() {
      this.showbar4 = false;
      this.request({
        url: "/v1.0/Count/getLeaveAreaCount",
        method: "GET",
        params: {
          zrCompanyId: this.qy_zrCompanyId,
        },
      }).then((res) => {
        if (res.success && res.data.length > 0) {
          this.bar4.legend.data = [];
          this.bar4.series = [];
          this.bar4.xAxis[0].data = ["离区原因统计"];
          res.data.map((item) => {
            this.bar4.legend.data.push(item.description);
            this.bar4.series.push({
              name: item.description,
              data: [item.count],
              label: {
                show: true,
                position: "top",
                color: "#4d2673",
                formatter: "{c}",
              },
              type: "bar",
              barGap: 0,
              color: `rgb(${Math.floor(Math.random() * 256)},${Math.floor(
                Math.random() * 256
              )},${Math.floor(Math.random() * 256)})`,
              smooth: true,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowOffsetY: -2,
                  shadowColor: "rgba(0, 0, 0, 0.3)",
                },
              },
            });
          });

          this.showbar4 = true;
        }
      });
    },
    getIndustrySignUpCount() {
      this.showbar3 = false;
      this.request({
        url: "/v1.0/Count/getIndustrySignUpCount",
        method: "GET",
        params: {
          zrCompanyId: this.qy_zrCompanyId,
        },
      }).then((res) => {
        if (res.success) {
          this.bar3.legend.data = [];
          this.bar3.series = [];
          this.bar3.xAxis[0].data = ["企业行业分布"];
          res.data.map((item) => {
            this.bar3.legend.data.push(item.industry);
            this.bar3.series.push({
              name: item.industry,
              data: [item.companyCount],
              label: {
                show: true,
                position: "top",
                color: "#4d2673",
                formatter: "{c}",
              },
              type: "bar",
              barGap: 0,
              color: `rgb(${Math.floor(Math.random() * 256)},${Math.floor(
                Math.random() * 256
              )},${Math.floor(Math.random() * 256)})`,
              smooth: true,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowOffsetY: -2,
                  shadowColor: "rgba(0, 0, 0, 0.3)",
                },
              },
            });
          });
          this.showbar3 = true;
        }
      });
    },
    //获取企业数量统计
    getCompanyCount() {
      this.request({
        url: "/v1.0/Count/getCompanyCount",
        method: "GET",
        params: {
          zrCompanyId: this.qy_zrCompanyId,
        },
      }).then((res) => {
        const { count, leaveAreaCount } = res.data;
        (this.xianshuo.count = count),
          (this.xianshuo.leaveAreaCount = leaveAreaCount);
      });
    },
    //获取所有项目状态数量
    getProjectStatusCount() {
      this.request({
        url: "/v1.0/Count/getProjectStatusCount2",
        method: "GET",
        params: {
          startTime: dateFormat(this.value_x1, "YYYY-MM-DD"),
          endTime: dateFormat(this.value_x2, "YYYY-MM-DD"),
          zrCompanyId: this.xm_zrCompanyId,
        },
      }).then((res) => {
        this.StatisticsData = res.data;
        this.$forceUpdate();
      });
    },
    //获取线索企业数量
    getCount() {
      this.request({
        url: "/v1.0/Count/getCount2",
        method: "GET",
        params: {
          startTime: dateFormat(this.value_x1, "YYYY-MM-DD"),
          endTime: dateFormat(this.value_x2, "YYYY-MM-DD"),
          zrCompanyId: this.xm_zrCompanyId,
        },
      }).then((res) => {
        const { cluesCount, projectCount, companyCount, qyCompanyCount } =
          res.data;
        this.xianshuo.cluesCount = cluesCount;
        this.xianshuo.projectCount = projectCount;
        this.xianshuo.companyCount = companyCount;
        this.xianshuo.qyCompanyCount = qyCompanyCount;
        this.$forceUpdate();
      });
    },
    //项目所属企业统计
    getCompanyProjectCount() {
      this.request({
        url: "/v1.0/Count/getCompanyProjectCount",
        method: "GET",
      }).then((res) => {
        if (res.success && res.data.length > 0) {
          this.bar1.legend.data = [];
          this.bar1.series = [];
          this.bar1.xAxis[0].data = ["项目所属企业统计"];
          res.data.map((item) => {
            this.bar1.legend.data.push(item.companyName);
            this.bar1.series.push({
              name: item.companyName,
              data: [item.projectCount],
              label: {
                show: true,
                position: "top",
                color: "#4d2673",
                formatter: "{c}",
              },
              type: "bar",
              barGap: 0,
              color: `rgb(${Math.floor(Math.random() * 256)},${Math.floor(
                Math.random() * 256
              )},${Math.floor(Math.random() * 256)})`,
              smooth: true,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowOffsetY: -2,
                  shadowColor: "rgba(0, 0, 0, 0.3)",
                },
              },
            });
          });
        }
      });
    },
    //企业行业分布
    getIndustryCompanyCount() {
      this.bar2status = false;
      this.request({
        url: "/v1.0/Count/getIndustryCompanyCount2",
        method: "GET",
        params: {
          startTime: dateFormat(this.value_x1, "YYYY-MM-DD"),
          endTime: dateFormat(this.value_x2, "YYYY-MM-DD"),
          zrCompanyId: this.xm_zrCompanyId,
        },
      }).then((res) => {
        if (res.success) {
          this.bar2status = true;
          this.bar2.legend.data = [];
          this.bar2.series = [];
          this.bar2.xAxis[0].data = ["企业行业分布"];

          if (res.data.length == 0) {
            let mokedef = [
              "科学研究和技术服务业",
              "租赁和商务服务业",
              "制造业",
              "信息传输、软件和信息技术服务业",
              "批发和零售业",
              "文化、体育和娱乐业",
              "农、林、牧、渔业",
              "房地产业",
              "金融业",
            ];
            for (let i = 0; i < mokedef.length; i++) {
              this.bar2.legend.data.push(mokedef[i]);
              this.bar2.series.push({
                name: mokedef[i],
                data: [0],
                label: {
                  show: true,
                  position: "top",
                  color: "#4d2673",
                  formatter: "{c}",
                },
                type: "bar",
                barGap: 0,
                color: `rgb(${Math.floor(Math.random() * 256)},${Math.floor(
                  Math.random() * 256
                )},${Math.floor(Math.random() * 256)})`,
                smooth: true,
                itemStyle: {
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowOffsetY: -2,
                    shadowColor: "rgba(0, 0, 0, 0.3)",
                  },
                },
              });
            }
            return;
          }

          res.data.map((item) => {
            this.bar2.legend.data.push(item.industry);
            this.bar2.series.push({
              name: item.industry,
              data: [item.companyCount],
              label: {
                show: true,
                position: "top",
                color: "#4d2673",
                formatter: "{c}",
              },
              type: "bar",
              barGap: 0,
              color: `rgb(${Math.floor(Math.random() * 256)},${Math.floor(
                Math.random() * 256
              )},${Math.floor(Math.random() * 256)})`,
              smooth: true,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowOffsetY: -2,
                  shadowColor: "rgba(0, 0, 0, 0.3)",
                },
              },
            });
          });
        }
      });
    },
    refresh() {
      //漏斗统计
      this.bar.dataset.source = [
        [
          "Product",
          "线索",
          "初审通过",
          "完成项目考察评分",
          "上会通过",
          "签约",
          "",
          "",
        ],
      ];
      this.$nextTick(() => {
        this.seconds = 3;
        const bar = this.$refs.bar;
        this.request({
          url: "/v1.0/ThePublic/getProjectTotalCount",
          method: "GET",
          params: {
            StartTime: this.value1,
            EndTime: this.value2,
            Monthly: this.Monthly,
            zrCompanyId: this.dou_zrCompanyId,
          },
        }).then((res) => {
          if (res.success) {
            res.data.map((item) => {
              this.bar.dataset.source.push([
                item.time,
                item.clueCount > 0 ? item.clueCount : "",
                item.projectCount > 0 ? item.projectCount : "",
                // item.completeScoreCount > 0 ? item.completeScoreCount : "",
                // item.inChargePassedCount > 0 ? item.inChargePassedCount : "",
                item.supervisorPassedCount > 0
                  ? item.supervisorPassedCount
                  : "",
                item.mettingPassedCount > 0 ? item.mettingPassedCount : "",
                item.signUpCount > 0 ? item.signUpCount : "",
              ]);
            });
          }
        });
      });
    },
    getCompanyProjectComplatedCount() {
      this.request({
        url: "/v1.0/Count/getCompanyProjectComplatedCount",
        method: "GET",
        params: {
          startYear: this.value3,
          endYear: this.value4,
          zrCompanyId: this.qy_zrCompanyId,
        },
      }).then((res) => {
        console.log(res, 6633);
        if (res.success) {
          let Income = [];
          let CompletedIncome = [];
          let yAxis = [];
          let cids = [];
          let pids = [];
          res.data.sort((a, b) => {
            return a.taxYear - b.taxYear;
          });
          res.data.forEach((item) => {
            Income.push({
              value: item.income,
              cids: item.cids,
              pids: item.pids,
              year: item.taxYear,
            });
            CompletedIncome.push({
              value: item.completedIncome,
              cids: item.cids,
              pids: item.pids,
              year: item.taxYear,
            });
            yAxis.push(item.taxYear + "年");
            cids.push(item.cids);
            pids.push(item.pids);
          });

          this.echartBar10.yAxis.data = yAxis;
          this.echartBar10.series[0].data = Income;
          this.echartBar10.series[1].data = CompletedIncome;
        }
      });
    },

    // 获取项目统计页面数据
  },
  async created() {
    let res = await getAllSassOrg();
    let { orgList, orgId, roleStr } = res.data;
    this.zrShow = ["系统管理", "全局管理"].includes(roleStr);
    this.zrOptions = [
      { text: "请选择", value: 0 },
      ...orgList.map((item) => ({ text: item.orgName, value: item.id })),
    ];
    if (orgId) {
      this.zrCompanyId = orgId;
    }
    this.dou_zrCompanyId = this.zrCompanyId;
    this.xm_zrCompanyId = this.zrCompanyId;
    this.qy_zrCompanyId = this.zrCompanyId;
    this.fw_zrCompanyId = this.zrCompanyId;
    this.yl_zrCompanyId = this.zrCompanyId;
    // this.getProjectStatusCount();
    // this.getCount();
    // this.getCompanyProjectCount();
    // this.getIndustryCompanyCount();
    // this.getCompanyCount();
    // this.getIndustrySignUpCount();
    // this.getLeaveAreaCount();
    // this.getLeaveAreaTimeCount();
    // this.getAccessCount();
    // this.getAccessTimePeriodCount();
    // this.getAccessIpAddressCount();
    // this.getAccessTrendCount();
    // this.getCompanyProjectComplatedCount();
    // this.searchxmyl();

    if (this.$route.query.val != undefined) {
      this.xmform.state = this.$route.query.status;
      this.yl_zrCompanyId = this.$route.query.val;
      this.setState(this.xmform.state);
      // this.$nextTick(() => {
      //   if (this.$route.query.status && this.$route.query.status.length > 2) {
      //     this.yl_zrCompanyId = this.$route.query.val;
      //     this.xmform.state = this.$route.query.status;
      //     this.setState(this.xmform.state);
      //   } else {
      //     this.setState("")
      //   }
      // });
    }
    // this.refresh();
    // this.setState(this.xmform.state)
  },
  computed: {
    countTexta() {
      let a = this.xmyl.tableList;
      let httz = 0;
       a.filter((item) => !isEmpty(item.httz) && !isNaN(item.httz / 1))
        .reduce((p, l) => (p += l.httz / 1), 0);
      if (httz) {
        var sum = Math.round(httz * 1000);
        var s = sum + "";
        var strsum = "";
        for (var i = 0; i < s.length; i++) {
          strsum += s[i];
          if (s.length - i == 4) {
            strsum += ".";
          }
        }
        return strsum;
      }
      return 0;
    },
    countTextb() {
      let a = this.xmyl.tableList;
      let dcsum = a
        .filter((item) => !isEmpty(item.ysCount) && !isNaN(item.ysCount / 1))
        .reduce((p, l) => (p += l.ysCount / 1), 0);
      if (dcsum) {
        var sum = Math.round(dcsum * 1000);
        var s = sum + "";
        var strsum = "";
        for (var i = 0; i < s.length; i++) {
          strsum += s[i];
          if (s.length - i == 4) {
            strsum += ".";
          }
        }
        return strsum;
      }
      return 0;
    },
  },
  watch: {
    active(nval) {
      if (nval != 4) {
        this.showMore = true;
        this.xmform = {
          projectName: "", // 项目名称
          zrCompanyId: 0, // 责任单位
          companyName: "", // 投资主体
          buildType: "", // 建设性质
          projectType: "-1", // 产业类别
          state: "", // 项目状态
          canye: "", // 产业方向
          httzft: "大于等于", // 合同投资额计算符
          httzftVal: "", // 合同投资额对比值
          dcysft: "大于等于", // 达产营收值计算符
          dcysftVal: "", // 达产营收值对比值
          phzqft: "大于等于", // 项目平衡周期（年）计算符
          phzqftVal: "", // 项目平衡周期（年）对比值
          htfcft: "大于等于", // 合同期内给予政策扶持总金额计算符
          htfcftVal: "", // 合同期内给予政策扶持总金额对比值
          qyssft: "大于等于", // 合同期内区级税收总贡献计算符
          qyssftVal: "", // 合同期内区级税收总贡献对比值
          signDateStart: "", // 签约时间范围-开始
          signDateEnd: "", // 签约时间范围-结束
          htType: "", // 合同类型
        };
        this.xmyl.tableList = [];
        this.isNoData = false;
      }
    },
  },
};
</script>


<style   >
.item-title {
  min-width: 156px;
  font-family: 黑体;
  text-align: right;
}

.item-clis {
  display: flex;
  flex-direction: row-reverse;
  color: rgb(36, 144, 248);
}

.title-text {
  color: #323233;
  font-weight: 500;
}

.titled-text {
  color: #646566;
  font-size: 14px;
}

button {
  border: 1px solid #1779cc;
  border-radius: 2em;
  background-color: #fff;
  color: #1779cc;
  cursor: pointer;
  font: inherit;
  transition: opacity 0.3s;

  &:focus {
    outline: none;
    box-shadow: 0 0 1px #4fc08d;
  }

  &:active {
    background: rgba(79, 192, 141, 0.2);
  }

  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.round {
    width: 1.6em;
    height: 1.6em;
    position: relative;

    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 9px;
      height: 1px;
      background-color: #42b983;
    }

    &::after {
      width: 1px;
      height: 9px;
    }

    &.expand::after {
      display: none;
    }
  }
}

figure {
  display: inline-block;
  position: relative;
  margin: 2em auto;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-shadow: 0 0 45px rgba(0, 0, 0, 0.2);
  padding: 1.5em 2em;
  min-width: calc(40vw + 4em);
}

#logo {
  display: inline-block;
  width: 128px;
  height: 128px;
  pointer-events: none;
}

@media (max-width: 980px) {
  p {
    display: flex;
    justify-content: center;

    select {
      text-indent: calc(50% - 1em);
    }

    select,
    label {
      border: 1px solid #4fc08d;
      border-radius: 2em;
      background-color: #fff;
      color: #42b983;
      cursor: pointer;
      transition: opacity 0.3s;
    }

    button,
    input,
    select,
    label {
      flex: 1 0;
      margin: 0 0.5em;
      padding: 0;
      line-height: 2.4em;
      max-width: 40vw;
      border-radius: 2px;
      font-size: 0.8em;
    }

    select {
      -webkit-appearance: none;
    }

    input[type="checkbox"] {
      display: none;

      &:checked + label {
        background: #42b983;
        color: #fff;
      }
    }
  }

  figure {
    width: 100vw;
    margin: 1em auto;
    padding: 0 1em;
    border: none;
    border-radius: 0;
    box-shadow: none;

    .echarts {
      width: 100%;
      min-width: 0;
      height: 75vw;
    }
  }
}

.renderer {
  position: fixed;
  top: 10px;
  left: 10px;
  font-size: 12px;
  text-align: center;

  button {
    float: left;
    position: relative;
    width: 48px;
    border-radius: 4px;

    &.active {
      z-index: 1;
      background-color: #4fc08d;
      color: #fff;
    }

    &:first-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    &:last-child {
      left: -1px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}

.zhezhao {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 99;
}

.wrapper {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.el-timeline-item__tail {
  border-left: 2px solid #1779cc;
}
</style>
